export default "__VITE_ASSET__fd12eb25__"